import { Component, OnInit, Input, OnChanges, SimpleChanges, AfterViewInit } from '@angular/core';
import * as L from 'leaflet';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-energymeter-map',
  templateUrl: './energymeter-map.component.html',
  styleUrls: ['./energymeter-map.component.scss'],
  standalone:true,
  imports: [CommonModule,]
})
export class EnergymeterMapComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() allClients: any[];
  @Input() sites:any[];
  private map: L.Map;
  private markersLayer: L.LayerGroup;
  public userID: any;

  constructor(private router: Router) { 


    if (localStorage.getItem("role") === "ACCOUNT_MANAGER") {
      this.userID = localStorage.getItem("admin_client_id");
    } else if (localStorage.getItem("role") === "USER") {
      this.userID = localStorage.getItem("associated_clientid");
    } else if (localStorage.getItem("role") === "ADMIN") {
      this.userID = localStorage.getItem("admin_client_id");
    } else {
      this.userID = localStorage.getItem("user_id");
    }


  }

  ngOnInit(): void {
    this.initMap();
    console.log(this.sites)
    console.log(this.allClients)
   }

  ngAfterViewInit(): void {
    
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['allClients'] && !changes['allClients'].isFirstChange()) {
      this.updateMarkers();
    }
  }

  private initMap(): void {
    // Ensure the map container is available
    const mapElement = document.getElementById('energymetermap');
    if (!mapElement) {
      console.error('Map container not found');
      return;
    }

    this.map = L.map(mapElement).setView([20.5937, 78.9629], 4); // Center on India
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap contributors'
    }).addTo(this.map);

    this.markersLayer = L.layerGroup().addTo(this.map);
    this.updateMarkers(); // Update markers after map initialization
  }

  private updateMarkers(): void {
    console.log(this.allClients)
    if (!this.map || !this.markersLayer) {
      return;
    }

    this.markersLayer.clearLayers(); // Clear existing markers

    const markerIcon = L.icon({
      iconUrl: 'assets/marker-icon.png', // Adjust the path as per your project structure
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      tooltipAnchor: [16, -28],
      shadowSize: [41, 41]
    });

  //   this.allClients.forEach(client => {
  //     console.log(client,'client.............................')
  //     const latitude = client.latitude;
  //     const longitude = client.longitude;

  //     const marker = L.marker([latitude, longitude], { icon: markerIcon });
  //     marker.bindTooltip(`<b>${client.company_name}</b><br> ${client.address_1}<br> ${client.address_2}`)
  //       .on('click', () => {    
  //         alert('ddddpppp')      
  //         this.navigateToAssetsPage(client.site_id, client.application_id);
  //       });

  //     this.markersLayer.addLayer(marker);
  //   });
  // }
    
    this.allClients.forEach(client => {
      let x=this.sites.filter(site=>site.id==client.site_id)
      console.log(x)
      const latitude = client.latitude;
      const longitude = client.longitude;
      
      const marker = L.marker([latitude, longitude], { icon: markerIcon });
    
      // marker.bindTooltip(`<b>${client.company_name}</b><br> ${client.address_1}<br>`,{autoPan:false});
      marker.bindTooltip(`<b>${x[0].name}</b><br>${x[0].address_1}`);
      // marker.bindPopup(`<b>${client.company_name}</b><br> ${client.address_1}<br>`,{autoPan:false})
      marker.on('click', () => {    
        this.navigateToAssetsPage(client.site_id, client.application_id);
      });
    
      this.markersLayer.addLayer(marker);
    });
    
  }


  navigateToAssetsPage(site_id: any, application_id: any): void {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        site_id: site_id,
        application_id: application_id,
        showEmeter:1,
        showStat:1,
        tabName:'tab-3'
      }
    };

    if (localStorage.getItem("role") === "ADMIN") {
      this.router.navigate(['/device-report-new'], navigationExtras);
    }else if(localStorage.getItem("role") === "CLIENT"){
      this.router.navigate(['/device-reports'], navigationExtras);
    }


    
  }
}
